import { ITranslate } from "@/interfaces/ITranslate";

export const checklistTranslate: ITranslate = {
  reviewPeriod: "revisar cada",
  includeEquipmentSection: "incluye revisión del equipamiento",
  includeObservationSection: "incluye observaciones",
  includeDocumentationSection: "incluye revisión de la documentación",
  isActive: "el estado",
};
